import styled from "@emotion/styled"

const OrderedList = styled.ol``

export default OrderedList
